import { User } from "./user.model";

export class Invitation {
    public id: number;
    public email: string;
    public role: number;
    public namedRole: string;
    public status: string;
    public expires_at: string;
    public created_at: string;
    public inviter: User;
    public used_at?: Date;
    public cancelled_at?: Date;
    public user?:User;
    public role_name?:string;

    constructor(
        id:number,
        email: string,
        role: number,
        status: string,
        expires_at: string,
        created_at: string,
        inviter: User
    ) {
        this.id = id;
        this.email = email;
        this.role = role;
        this.namedRole = role === 0 ? "User" : "Admin"
        this.status = status;
        this.expires_at = this.dateToString(new Date(expires_at));
        this.created_at = this.dateToString(new Date(created_at));
        
        this.inviter = inviter;
    }

    dateToString(date:Date) {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    }
}